export default [
  {
    path: '/checklist-pendente',
    name: 'ChecklistPendente',
    component: () => import('./ChecklistPendenteList'),
    meta: {
      routerGo: '/imovel-new',
      routerEdit: '/imovel-edit',
      routerCotas: '/imovel/:id/cotas',
      domain: 'ChecklistPendente',
      sidebar: true,
      icon: 'store_mall_directory',
      title: 'Checklist Pendentes',
    },
  },
];



// WEBPACK FOOTER //
// ./src/app/ChecklistPendente/ChecklistPendenteRouter.js